import React, { use, useContext, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from "react-spinners";
import LOGO from '../../images/CLS-Logo.png';

function ChangePasswordPage() {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({'new_password': '', 'confirm_password': ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const navigate = useNavigate();
    const {setUserProfile} = useContext(UserContext);
    const location = useLocation();

    const {token} = useParams();

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        if (formFields.new_password != formFields.confirm_password) {
            setTostMessage({
                messageType: "warning",
                message: 'Passwords must match',
            })
            return;
        }
        if (formFields.new_password == "" || formFields.confirm_password == "") {
            setTostMessage({
                messageType: "warning",
                message: 'Passwords cannot be empty',
            })
            return;
        }
        formData.append("new_password", formFields.new_password);
        formData.append("token", token);
        const date = new Date();
        let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours

        try {
            const response = await axios.post(base_url + '/auth/change_password.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    // access: cookies.urbexEnterpriseUserToken,
                },
            });
            console.log(response);
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                navigate("/login");
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }
  return (
    <div className="relative h-screen h-full px-4">
        <div className="min-h-screen bg-gray-50 flex items-center justify-center relative">
            {/* Top Right Help/Support */}
            <div className="absolute top-4 right-6 flex space-x-4 text-sm text-gray-600">
                <a href="#" className="hover:underline">Help</a>
                <a href="#" className="hover:underline">Support</a>
            </div>

            {/* Login Card */}
            <div className='w-full flex flex-col items-center justify-center'>
                <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[30px]'>
                    <img src={LOGO} className="h-[80px] rounded-full mr-2" alt="logo" />
                    {/* <h1 className="font-bold text-[17px]">CHILDREN'S LANGUAGE SCHOOL</h1> */}
                </div>
                <div className="bg-white p-8 rounded-sm shadow-md w-full max-w-md">
                    <div className="mb-6 text-center">
                    <h1 className="text-2xl font-semibold text-gray-800">Children’s Language School</h1>
                    <p className="text-sm text-gray-500 mt-1">Change your password</p>
                    </div>

                    <div className='my-4'>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                        <input
                        type="password"
                        placeholder="Enter New Password"
                        className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow"
                        onChange={(e) => setFormFields({...formFields, new_password: e.target.value})}
                        />
                    </div>

                    <div className="mb-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Passowrd</label>
                        <input
                        type="password"
                        placeholder="Confirm New Password"
                        className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow"
                        onChange={(e) => setFormFields({...formFields, confirm_password: e.target.value})}
                        />
                    </div>

                    <button
                        onClick={() => submit()}
                        className="w-full bg-yellow mt-5 hover:bg-yellow-500 text-black font-medium py-2 rounded-md transition"
                    >
                        {loading ? (
                            <ClockLoader
                                color={'#212121'}
                                loading={loading}
                                size={25}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            ) : 'Change Password'
                        }
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ChangePasswordPage;
